<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h3>
            Datenbank <b>{{ database.caption }}</b> Teilen
          </h3>
          <p>Teilen Sie Ihre Datenbank mit anderen Personen.</p>
          <form @submit.prevent="save()">
            <input
              placeholder="E-Mail-Adresse"
              v-model="shareParams.email"
              type="email"
              required
            />
            <generalDropdown className="start-dropdown">
              <template v-slot:selectFilter>
                <span class="line-clamp"
                  >{{ getShareParamsAccessLevelName(shareParams.accessLevel) }}
                </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="level in getDropDownAccessLevels"
                  :key="level.name"
                  @click="setShareParamsAccessLevel(level.name)"
                >
                  {{ level.caption }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
            <div class="message-container">
              <p v-show="isErrorMsgVisible" class="error">
                {{ errorMessage }}
              </p>
              <p v-show="isSuccessMsgVisible" class="success">
                {{ successMessage }}
              </p>
            </div>
            <div class="footer">
              <button class="btn-black" type="submit">Teilen</button>
            </div>
          </form>
          <div class="tab container" v-show="this.tablePolicies.length > 0">
            <div
              v-if="this.tablePolicies.length > 0"
              class="table-share-contact-info-wrap"
            >
              <p>Diese Personen haben bereits Zugriff:</p>
              <div
                v-if="tablePolicies.length > 0"
                class="table-share-contact-info"
              >
                <div
                  class="user-identity"
                  v-for="p in getSortedTablePolicies"
                  :key="p.id"
                >
                  <p>{{ p.email }}</p>
                  <generalDropdown
                    :disabled="p.email == 'public'"
                    className="start-dropdown"
                    v-if="p.access_level != 'owner'"
                  >
                    <template v-slot:selectFilter>
                      <span class="line-clamp"
                        >{{ getShareParamsAccessLevelName(p.access_level) }}
                      </span>
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="level in getDropDownAccessLevels"
                        :key="level.name"
                        @click="changePolicy(p, level.name)"
                      >
                        {{ level.caption }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                  <span class="owner-caption" v-else>Besitzer</span>
                  <i
                    class="fa fa-trash"
                    aria-hidden="true"
                    @click="removePolicy(p)"
                    v-if="p.access_level != 'owner'"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDataBaseAccessRights,
  shareDataBaseTable,
} from '../../services/userTable';
import GeneralDropdown from '../core/general-dropdown.vue';
export default {
  name: 'tableShareModal',
  data() {
    return {
      accessLevels: [
        {
          name: 'read',
          caption: 'Kann lesen',
        },
        {
          name: 'write',
          caption: 'Kann bearbeiten',
        },
        {
          name: 'full_access',
          caption: 'hat Vollzugriff',
        },
        {
          name: 'owner',
          caption: 'Besitzer',
        },
      ],

      shareParams: {
        email: null,
        accessLevel: 'read',
      },
      tablePolicies: [],
      isErrorMsgVisible: false,
      isSuccessMsgVisible: false,
      successMessage: null,
      errorMessage: null,
    };
  },
  props: {
    database: { type: Object, required: true },
  },
  methods: {
    close: function () {
      this.$emit('close');
    },

    save: async function () {
      await this.shareTable();
      this.$emit('save');
    },
    async shareTable() {
      try {
        let payload = {
          recipient: this.shareParams.email,
          access_level: this.shareParams.accessLevel,
        };
        const response = await shareDataBaseTable(this.database.name, payload);

        if (response && response.status === 200 && response.data) {
          this.getAccessRights();
          this.showSuccess('Datenbank wurde erfolgreich geteilt.');
        }
      } catch (error) {
        if (error && error.status === 400 && error.data && error.data.message) {
          let message = error.data.message;
          if (message === 'User is owner') {
            this.showError(
              'Dieser User hat die Datenbank erstellt, du kannst ihn nicht einladen.'
            );
          } else if (message === 'Email not found') {
            this.showError(
              'Die angegebene Email-Adresse konnte nicht gefunden werden.'
            );
          } else {
            // eslint-disable-next-line no-console
            console.log({ error });
          }
        }
      }
    },
    async getAccessRights() {
      try {
        const response = await getDataBaseAccessRights(this.database.name);

        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.length > 0
        ) {
          this.tablePolicies = response.data;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({ error });
      }
    },

    removePolicy: function (p) {
      const url = `${process.env.VUE_APP_DATA_API}/user-tables/${this.database.name}/share`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      let payload = {
        policy_id: p.id,
      };

      fetch(url, {
        headers: myHeaders,
        body: JSON.stringify(payload),
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 404) throw new Error('Email not found');
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else throw new Error('CORS');
        })
        // eslint-disable-next-line no-unused-vars
        .then((json) => {
          this.getAccessRights();
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
          } else {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        });
    },
    showError: function (msg) {
      this.errorMessage = msg;
      this.isErrorMsgVisible = true;
      setTimeout(() => {
        this.isErrorMsgVisible = false;
        this.errorMessage = null;
      }, 3000);
    },
    showSuccess: function (msg) {
      this.successMessage = msg;
      this.isSuccessMsgVisible = true;

      setTimeout(() => {
        this.isSuccessMsgVisible = false;
        this.successMessage = null;
      }, 3000);
    },
    changePolicy: function (p, accessName) {
      // Set params for shareTable
      this.$set(this.shareParams, 'email', p.email);
      this.$set(this.shareParams, 'accessLevel', accessName);

      this.shareTable();
    },
    setShareParamsAccessLevel(accessName) {
      this.shareParams.accessLevel = accessName;
    },
    getShareParamsAccessLevelName(accessLevel) {
      return this.accessLevels.find((level) => level.name == accessLevel)
        .caption;
    },
  },
  created() {
    this.getAccessRights();
  },
  computed: {
    getSortedTablePolicies() {
      return [...this.tablePolicies].sort((a, b) => {
        if (a.access_level === 'owner') return -1;
        if (b.access_level === 'owner') return 1;
        return 0;
      });
    },
    getDropDownAccessLevels() {
      return this.accessLevels.filter((el) => el.name !== 'owner');
    },
    user() {
      return this.$store.state.user;
    },
  },
  components: {
    GeneralDropdown,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 50%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  position: fixed;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 7%;
  height: 72%;
  overflow: unset;
  padding-bottom: 32px;
}
/* Style that has no refference*/
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: #70787e;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
  height: 100%;
}

.tab.container {
  padding: 0;
  height: calc(100% - 250px);
}

select {
  width: 70%;
}

/* Style that has no refference*/
.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

/* Style that has no refference*/
.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 25px;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}
/* Style that has no refference*/
ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

/* Style that has no refference*/
.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #70787e;
  margin: 30px 0px 13px 0px;
}

.tab .explenation {
  font-size: 13px;
  margin: 0;
}

/* Style that has no refference*/
.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 50%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}

/* Style that has no refference*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

input[type='email'] {
  width: 60%;
  background: #fbfbff;
  display: inline-block;
}

select {
  width: 40%;
  display: inline-block;
  border: none;
  margin-bottom: 0px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

/* Style that has no refference*/
.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  height: 65px;
  width: 105%;
}

.switch-group > label.caption {
  float: left;
  height: 53px;
  padding-top: 19px;
}

.radioOption {
  width: 100%;
  padding-bottom: 5px;
}

.radioOption .tools {
  padding: 15px;
  float: right;
}

.radioOption .tools .i {
  font-size: 15px;
}

.radioOption input {
  border: 0;
  background: transparent;
}

.radioOption input[type='text'] {
  width: 68%;
  margin-left: 9px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.radioOption input[type='radio'] {
  width: 21px;
  float: left;
  margin-bottom: 0;
  height: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}

.message-container {
  height: fit-content;
}

.message-container p {
  margin: 0;
  font-weight: 600;
}

.message-container .error {
  color: rgb(255, 51, 102);
}

.message-container .success {
  color: #52b266;
}

/* Style that has no refference*/
.access-management {
  padding: 0 0px 40px 0px;
}

.modal .content .user-identity {
  padding: 2px 0px 2px 0px;
}

.modal .content .user-identity > p {
  display: inline-block;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 55%;
}

.modal .content .user-identity > i {
  margin-left: 8px;
  cursor: pointer;
}

.modal .content .tab .user-identity .owner-caption {
  color: black;
  font-size: 14px;
  padding: 0;
}
.modal .user-identity ::v-deep button {
  padding: 0;
  line-height: 16px;
}
.modal .user-identity ::v-deep .btn-group {
  vertical-align: unset;
}
.table-share-contact-info-wrap {
  height: calc(100% - 30px);
}
.table-share-contact-info {
  height: calc(100% - (43px + 21px));
  overflow: auto;
}
</style>
